import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

const BASE = "/api/clinic/medication-plans";

export const medicationPlanApi = createApi({
  reducerPath: "medicationPlanApi",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  endpoints: (b) => ({
    listMedicationPlans: b.mutation({ query: (d) => apiFunction(d, `${BASE}/list-by-patient`, "POST") }),
    createMedicationPlans: b.mutation({ query: (d) => apiFunction(d, `${BASE}/create`, "POST") }),
    suggestMedicationPlans: b.mutation({ query: (d) => apiFunction(d, `${BASE}/create-from-prescription`, "POST") }),
    updateMedicationPlan: b.mutation({ query: (d) => apiFunction(d, `${BASE}/update`, "POST") }),
    pauseMedicationPlan: b.mutation({ query: (d) => apiFunction(d, `${BASE}/pause`, "POST") }),
    resumeMedicationPlan: b.mutation({ query: (d) => apiFunction(d, `${BASE}/resume`, "POST") }),
    endMedicationPlan: b.mutation({ query: (d) => apiFunction(d, `${BASE}/end`, "POST") }),
    medicationAdherence: b.mutation({ query: (d) => apiFunction(d, `${BASE}/adherence`, "POST") }),
  }),
});

export const {
  useListMedicationPlansMutation,
  useCreateMedicationPlansMutation,
  useSuggestMedicationPlansMutation,
  useUpdateMedicationPlanMutation,
  usePauseMedicationPlanMutation,
  useResumeMedicationPlanMutation,
  useEndMedicationPlanMutation,
  useMedicationAdherenceMutation,
} = medicationPlanApi;
